import { apiSlice, baseUrl } from "../../app/api/apiSlice";

export const ws_url = `${baseUrl.replace("http", "ws")}/ws/stream/{session_id}/`;
export const chatLogsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getChatLogs: builder.query({
      query: (params) => ({
        url: "/api/v1/resources/chatlogs/detailed/",
        params,
      }),
      providesTags: ["ChatLog"],
    }),
    fetchChatLogById: builder.query({
      query: (id) => `/api/v1/resources/chatlogs/${id}/`,
      providesTags: (result, error, id) => [{ type: "ChatLog", id }],
    }),
    createChatLog: builder.mutation({
      query: (args) => ({
        url: "/api/v1/resources/chatlogs/",
        method: "POST",
        body: args,
      }),
      invalidatesTags: ["ChatLog"],
    }),
    deleteChatLog: builder.mutation({
      query: (id) => ({
        url: `/api/v1/resources/chatlogs/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["ChatLog"],
    }),
  }),
});

export const {
  useGetChatLogsQuery,
  useFetchChatLogByIdQuery,
  useCreateChatLogMutation,
  useDeleteChatLogMutation,
} = chatLogsApiSlice;
